import { Autocomplete, TextField } from "@mui/material";
import { ListAltOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { useGetAllTagsQuery } from "@/pages/Private/redux/to-do/to-do.api";
import { autocompleteSx, sharedInputProps, sharedMenuProps } from "@/styles/sharedComponentStyles";

interface TagOption {
	tagId: number;
	tagName: string;
}

interface TagSelectProps {
	value: number | null | undefined;
	onChange: (tagId: number | null) => void;
}

/** The tag picker as it appears in both detail drawers. */
export default function TagSelect({ value, onChange }: TagSelectProps) {
	const { t } = useTranslation();
	const { data: tags } = useGetAllTagsQuery();

	const options: TagOption[] =
		tags
			?.filter((tag): tag is { id: number; name: string } => !!tag.id)
			.map((tag) => ({ tagId: tag.id, tagName: tag.name })) ?? [];

	return (
		<Autocomplete<TagOption>
			getOptionLabel={(option) => option.tagName}
			isOptionEqualToValue={(a, b) => a.tagId === b.tagId}
			options={options}
			renderInput={(params) => (
				<TextField
					placeholder={t("to-do.none")}
					{...params}
					InputProps={{
						...params.InputProps,
						startAdornment: (
							<>
								<ListAltOutlined sx={{ color: "action.active", fontSize: 18, mr: 0.5 }} />
								{params.InputProps.startAdornment}
							</>
						),
					}}
					inputProps={{ ...params.inputProps, ...sharedInputProps }}
				/>
			)}
			size="small"
			slotProps={{ paper: { sx: sharedMenuProps.PaperProps.sx } }}
			sx={autocompleteSx}
			value={options.find((option) => option.tagId === value) ?? null}
			onChange={(_, selected) => onChange(selected?.tagId ?? null)}
		/>
	);
}
